import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Content type',
    value: 'contentType',
  },
  {
    label: 'Link',
    value: 'clink',
  },
  {
    label: 'Title',
    value: 'title',
  },
  {
    label: 'Created',
    value: 'createdAt',
  },
  {
    action: ['edit', 'delete'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
